(() => {
  const updateContact = () => {
    const link = document.getElementById('webux-whatsapp-link');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.hostname !== 'wa.me' && url.hostname !== 'api.whatsapp.com') return;
    if (url.hostname === 'wa.me') url.pathname = '/5493484561671';
    else url.searchParams.set('phone', '5493484561671');
    if (link.href !== url.href) link.href = url.href;
  };
  updateContact();
  new MutationObserver(updateContact).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['href']});
})();